import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Box from "@mui/material/Box";
import FormLabel from "@mui/material/FormLabel";
import { TextMode, useCsAttribute, } from "@plansoft-configuration-renderer/framework";
import { MarkdownOrText } from "../Common/MarkdownOrText";
import { ConfigurationAttributeInfo, INFO_LAYOUT_PROPS_DEFAULTS, } from "../Info";
export function AttributeHeadline(props) {
    const { infoProps = INFO_LAYOUT_PROPS_DEFAULTS, textMode = TextMode.PlainText, } = props;
    const attribute = useCsAttribute();
    const labelText = attribute.name || attribute.id;
    return (_jsxs(Box, { className: "attribute-headline", sx: { display: "flex", alignItems: "center" }, children: [_jsx(FormLabel, { required: attribute.isRequired, disabled: !attribute.isAllowed, children: _jsx(MarkdownOrText, { text: labelText, textMode: textMode }) }), _jsx(ConfigurationAttributeInfo, Object.assign({}, infoProps))] }));
}
//# sourceMappingURL=AttributeHeadline.js.map